var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 61,
    rx: 30.5,
    fill: "#0072B9",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 25.2503L32 20M32 20L26.6667 25.2503M32 20V33.1256M44 30.5005V36.7998C44 38.27 44 39.0051 43.7094 39.5667C43.4537 40.0606 43.0457 40.4622 42.544 40.7139C41.9735 41 41.2268 41 39.7333 41H24.2667C22.7732 41 22.0265 41 21.456 40.7139C20.9543 40.4622 20.5463 40.0606 20.2906 39.5667C20 39.0051 20 38.27 20 36.7998V30.5005",
    stroke: "#0072B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1da643b628c010cd33c7f660aa6b16b1.svg";
export { ForwardRef as ReactComponent };